import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __TOPONYMY_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { HttpResponseList } from 'shell/models/http-response';
import { ListItemType } from 'shell/models/item-type';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';

interface TypeReasonProps {
  disabled?: boolean;
  value: string;
  id: string;
  name: string;
  label: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  required?: boolean;
}

const TypeReasonComponent = ({
  disabled,
  onChange,
  value,
  id,
  name,
  label,
  error: formError,
  required,
}: TypeReasonProps): React.ReactElement => {
  const [reasonsData] = useHttpFetch<HttpResponseList<ListItemType>, Array<ItemVM>>(
    `${__TOPONYMY_API_URL__}/areaCircolazione/civico/tipo`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
        loading: true,
        errorCatching: true,
      },
      transformer: (response) =>
        response.data?.payload.list.map((reason) => ({
          id: reason.key,
          value: reason.descrizione,
        })),
    }
  );

  const reasons: Array<ItemVM> = (reasonsData?.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel id={`${id}-label`} disabled={disabled} error={formError}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={name}
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={formError}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {reasons.map((reason: ItemVM) => (
          <MenuItem key={reason.id} value={reason.id}>
            {reason.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TypeReasonComponent.displayName = 'Estabilishment reason component';

const TypeReason = memo(TypeReasonComponent) as typeof TypeReasonComponent;

export default TypeReason;
